import MUISnackbar, { SnackbarProps } from "@mui/material/Snackbar";

const Snackbar = (props: SnackbarProps) => {
  return <MUISnackbar {...props} />;
};

export default Snackbar;
